import React, { useState } from 'react';
import { motion } from 'framer-motion';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendarAlt, FaUsers, FaUser, FaEnvelope, FaPhone } from 'react-icons/fa';

const Booking = () => {
  const [formData, setFormData] = useState({
    checkIn: null,
    checkOut: null,
    roomType: '',
    guests: 1,
    name: '',
    email: '',
    phone: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleDateChange = (date, field) => {
    setFormData({ ...formData, [field]: date });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Booking submitted! (This is a demo)');
    // In real app, send to backend
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-highlight to-background py-16">
      <div className="max-w-4xl mx-auto px-4">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-4">Book Your Luxurious Stay</h1>
          <p className="text-xl text-secondary">Secure your perfect getaway with ease</p>
        </motion.div>

        <motion.form
          onSubmit={handleSubmit}
          className="bg-background p-8 md:p-12 rounded-2xl shadow-2xl"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <motion.div
              className="relative"
              whileFocusWithin={{ scale: 1.02 }}
            >
              <label className="block text-sm font-serif font-semibold text-primary mb-2 flex items-center">
                <FaCalendarAlt className="mr-2 text-accent" />
                Check-in Date
              </label>
              <DatePicker
                selected={formData.checkIn}
                onChange={(date) => handleDateChange(date, 'checkIn')}
                className="w-full p-4 border-2 border-highlight rounded-lg focus:outline-none focus:border-accent transition-colors"
                placeholderText="Select check-in date"
                dateFormat="MMMM d, yyyy"
                minDate={new Date()}
                required
              />
            </motion.div>
            <motion.div
              className="relative"
              whileFocusWithin={{ scale: 1.02 }}
            >
              <label className="block text-sm font-serif font-semibold text-primary mb-2 flex items-center">
                <FaCalendarAlt className="mr-2 text-accent" />
                Check-out Date
              </label>
              <DatePicker
                selected={formData.checkOut}
                onChange={(date) => handleDateChange(date, 'checkOut')}
                className="w-full p-4 border-2 border-highlight rounded-lg focus:outline-none focus:border-accent transition-colors"
                placeholderText="Select check-out date"
                dateFormat="MMMM d, yyyy"
                minDate={formData.checkIn || new Date()}
                required
              />
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <motion.div whileFocusWithin={{ scale: 1.02 }}>
              <label className="block text-sm font-serif font-semibold text-primary mb-2">Room Type</label>
              <select
                name="roomType"
                value={formData.roomType}
                onChange={handleChange}
                className="w-full p-4 border-2 border-highlight rounded-lg focus:outline-none focus:border-accent transition-colors bg-background"
                required
              >
                <option value="">Select Room Type</option>
                <option value="standard">Standard Room</option>
                <option value="deluxe">Deluxe Room</option>
                <option value="suite">Suite</option>
                <option value="family">Family Room</option>
              </select>
            </motion.div>
            <motion.div whileFocusWithin={{ scale: 1.02 }}>
              <label className="block text-sm font-serif font-semibold text-primary mb-2 flex items-center">
                <FaUsers className="mr-2 text-accent" />
                Number of Guests
              </label>
              <input
                type="number"
                name="guests"
                value={formData.guests}
                onChange={handleChange}
                min="1"
                className="w-full p-4 border-2 border-highlight rounded-lg focus:outline-none focus:border-accent transition-colors"
                required
              />
            </motion.div>
          </div>

          <motion.div whileFocusWithin={{ scale: 1.02 }} className="mb-6">
            <label className="block text-sm font-serif font-semibold text-primary mb-2 flex items-center">
              <FaUser className="mr-2 text-accent" />
              Full Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-4 border-2 border-highlight rounded-lg focus:outline-none focus:border-accent transition-colors"
              placeholder="Enter your full name"
              required
            />
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <motion.div whileFocusWithin={{ scale: 1.02 }}>
              <label className="block text-sm font-serif font-semibold text-primary mb-2 flex items-center">
                <FaEnvelope className="mr-2 text-accent" />
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-4 border-2 border-highlight rounded-lg focus:outline-none focus:border-accent transition-colors"
                placeholder="your@email.com"
                required
              />
            </motion.div>
            <motion.div whileFocusWithin={{ scale: 1.02 }}>
              <label className="block text-sm font-serif font-semibold text-primary mb-2 flex items-center">
                <FaPhone className="mr-2 text-accent" />
                Phone
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full p-4 border-2 border-highlight rounded-lg focus:outline-none focus:border-accent transition-colors"
                placeholder="+977 123 456 789"
                required
              />
            </motion.div>
          </div>

          <motion.button
            type="submit"
            className="w-full bg-accent hover:bg-accent/90 text-primary font-serif font-bold py-4 px-8 rounded-full text-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Confirm Booking
          </motion.button>
        </motion.form>
      </div>
    </div>
  );
};

export default Booking;